import React from 'react';
import {
    billingPeriodTotalLabel,
    formatRon,
    planById,
    planQuote,
} from '../lib/plans';
import { useLivePlans } from '../lib/useLivePlans';

export function PlanPriceDisplay({
    plan,
    cycleId = 'monthly',
    size = 'lg',
    showPeriodTotal = true,
    variant = 'default',
}) {
    // Pull LIVE prices + cycle discounts so super-admin override changes propagate instantly.
    const { plans: livePlans, cycles: liveCycles } = useLivePlans();
    const baseP = typeof plan === 'string' ? planById(plan) : plan;
    // Prefer the live version of the same plan id (latest price), fall back to the prop.
    const p = livePlans.find((lp) => lp.id === baseP.id) || baseP;
    const cycle = liveCycles.find((c) => c.id === cycleId) || liveCycles[0];
    const q = planQuote(p, cycle);
    const isCard = variant === 'card';
    const sizeClass = size === 'sm' ? ' plan-price-display--sm' : size === 'md' ? ' plan-price-display--md' : '';
    const rootClass = `plan-price-display${isCard ? ' plan-price-display--card' : ''}${sizeClass}`;

    return (
        <div className={rootClass} data-testid={`plan-price-${p.id}`}>
            {q.showOriginalPrice && (
                <div className="plan-price-display__promo badge badge-magenta">
                    −{q.savingsPercent}% reducere
                </div>
            )}

            {q.showOriginalPrice && (
                <div className="plan-price-display__was">
                    {formatRon(q.originalMonthly)} RON/lună
                </div>
            )}

            <div className="plan-price-display__monthly">
                ~{formatRon(q.displayMonthly)} <span className="plan-price-display__monthly-unit">RON/lună</span>
            </div>

            {showPeriodTotal && (
                <div className="plan-price-display__total">
                    {billingPeriodTotalLabel(cycleId)}:{' '}
                    <strong>{formatRon(q.periodTotalNet)} RON + TVA</strong>
                </div>
            )}

            {showPeriodTotal && (
                <div className="plan-price-display__gross">
                    ≈ {formatRon(q.periodTotalGross)} RON cu TVA 21%
                </div>
            )}

            {q.savingsVsList > 0 && (
                <div className="plan-price-display__savings">
                    Economisești {formatRon(q.savingsVsList)} RON + TVA
                    {cycle.discountPercent > 0 && ` (−${cycle.discountPercent}% ${cycle.label.toLowerCase()})`}
                </div>
            )}
        </div>
    );
}
